<template>
  <page-blocks wide>
    <template v-slot:page-blocks-top>
      <tm-breadcrumbs-skeleton :count="3" />
    </template>

    <div>
      <tm-skeleton-hero-details class="mb-5" />
      <tm-skeleton-grid-details />
    </div>
  </page-blocks>
</template>

<script lang="ts">
import { defineComponent } from '@/composition/vue/compositionApi'
import PageBlocks from '@/components/layout/PageBlocks.vue'
import TmSkeletonHeroDetails from '@/components/shared/skeletons/TmSkeletonHeroDetails.vue'
import TmSkeletonGridDetails from '@/components/shared/skeletons/TmSkeletonGridDetails.vue'
import TmBreadcrumbsSkeleton from '@/components/shared/skeletons/TmBreadcrumbsSkeleton.vue'

export default defineComponent({
  components: {
    TmBreadcrumbsSkeleton,
    PageBlocks,
    TmSkeletonHeroDetails,
    TmSkeletonGridDetails,
  },
})
</script>
